/* global translations */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { ImageSvg } from '../image';
import PaymentsProgressBar from './PaymentsProgressBar';
import PaymentSuccessSubscription from './PaymentSuccessSubscription';
import PaymentSuccessSubscriptionVip from './PaymentSuccessSubscriptionVip';
import PaymentSuccessSubscriptionOther from './PaymentSuccessSubscriptionOther';
import PaymentSuccessHighlight from './PaymentSuccessHighlight';

const PaymentSuccess = (props) => {
  const {
    type,
    active,
    verificationStatus,
    messagesCharacterLimit,
  } = props;

  const typeInfo = () => {
    switch (type) {
      case 'subscription':
        return (
          <PaymentSuccessSubscription
            verificationStatus={verificationStatus}
            messagesCharacterLimit={messagesCharacterLimit}
          />
        );
      case 'subscription_vip':
        return (<PaymentSuccessSubscriptionVip />);
      case 'subscription_other':
        return (<PaymentSuccessSubscriptionOther />);
      case 'highlight':
        return (<PaymentSuccessHighlight />);
      default:
        return (
          <div className="mtm">
            <a href="/">{get(translations, 'txt: Sākums', '')}</a>
          </div>
        );
    }
  };

  return (
    <div className="paymentContainer paymentContainer--success">
      <PaymentsProgressBar
        active={active}
        type={type}
        verificationStatus={verificationStatus}
        success
      />
      <div className="paymentContainer-content dib bcl paxl">
        <div className="paymentContainer-successIcon dib vam mts mrm">
          <ImageSvg svg="icon-check-2" iconClass="icon--check-2" full />
        </div>
        <div className="paymentContainer-title--smaller dib vam">
          {get(translations, 'txt: Apmaksa notikusi veiksmīgi!', '')}
        </div>
        {typeInfo()}
      </div>
    </div>
  );
};

PaymentSuccess.propTypes = {
  type: PropTypes.string.isRequired,
  active: PropTypes.string,
  verificationStatus: PropTypes.string,
  messagesCharacterLimit: PropTypes.number,
};
PaymentSuccess.defaultProps = {
  active: null,
  verificationStatus: '',
  messagesCharacterLimit: null,
};

export default PaymentSuccess;
